import Vue from 'vue'
import vueSeamless from 'vue-seamless-scroll'
Vue.component('vue-seamless-scroll', vueSeamless)
